import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IAccountUserMapping, IUser } from "@app/interfaces/IUser";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { AccountUserMappingService } from "../accountUserMapping.service";
import { UsersService } from "../users.service";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private readonly http: HttpClient,
        private readonly accountUserMappingService: AccountUserMappingService,
        private readonly usersService: UsersService) { }

    saveUser(user: IUser): Observable<number> {
        return this.http.post<number>(`/api/users/`, user, { params: { userLanguage: user.newUserLanguageCode } });
    }

    saveUserWithAccountMapping(user: IUser): Observable<IAccountUserMapping> {
        if (user.Id > 0) {
            return this.accountUserMappingService.postAccountUserMapping(user.Email, user.CurrentAccountUserMapping);
        }

        return this.saveUser(user).pipe(mergeMap(userId => {
            return this.accountUserMappingService.postAccountUserMapping(user.Email, user.CurrentAccountUserMapping);
        }))
    }

    isCurrentUserOnFoundationPlatform(): boolean {
        // TODO the original method used here uses $rootScope... need to spend some time investigating the alternatives
        return this.usersService.isCurrentUserOnFoundationPlatform();
    }

    getLoginToken(userId: number): Observable<string> {
        return this.http.get(`/api/users/token/${userId}`, { responseType: "text" });
    }
}
